

import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";

const FooterContainer = styled.footer`
  background: #02417cff;
  color: #fff;
  text-align: center;
  padding: 40px 20px;
  margin-top: 50px;
`;

const FooterLinks = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* small screen pe links wrap ho jayein */

  a {
    color: #ddd;
    margin: 8px 15px;
    text-decoration: none;
    font-size: 0.95rem;
    transition: color 0.3s ease;

    &.active {
      color: #ff9900; /* Active link Amazon orange */
      font-weight: bold;
    }

    &:hover {
      color: #ff9900;
    }
  }

  /* Tablet view */
  @media (max-width: 768px) {
    a {
      font-size: 0.9rem;
      margin: 6px 12px;
    }
  }

  /* Mobile view */
  @media (max-width: 480px) {
    flex-direction: column; /* links neeche neeche aa jayein */
    align-items: center;

    a {
      margin: 8px 0;
      font-size: 0.85rem;
    }
  }
`;


const SocialIcons = styled.div`
  margin: 20px 0;

  a {
    margin: 0 10px;
    font-size: 1.5rem;
    color: #ddd;

    &:hover {
      color: #ff9900;
    }
  }
`;

const Disclaimer = styled.p`
  font-size: 1rem;
  color: #bbb;
  margin-top: 20px;
  line-height: 1.5;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 0 10px; /* thoda spacing for small screens */
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
    line-height: 1.4;
    padding: 0 5px;
  }
`;

const CopyRight = styled.p`
  margin-top: 10px;
  font-size: 0.9rem;
  color: #888;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLinks>
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/aboutus">About Us</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/privacy-policy">Privacy Policy</NavLink>
        <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
        <NavLink to="/affiliate-disclosure">Affiliate Disclosure</NavLink>
        <NavLink to="/contactus">Contact</NavLink>
      </FooterLinks>

      <SocialIcons>
        <a href="https://www.facebook.com/share/1JKVwdxFRp/"><FaFacebook /></a>
        <a href="https://www.instagram.com/customize_printing_art?igsi=MXYxMmJ3NzJkOWphYw=="><FaInstagram /></a>
        <a href="#"><FaTwitter /></a>
        <a href="https://wa.me/message/754G7PJJZFH2N1"><FaWhatsapp /></a>
      </SocialIcons>

      <Disclaimer>
        As an Amazon Associate, we earn from qualifying purchases.  
        This website participates in the Amazon Services LLC Associates Program, 
        an affiliate advertising program designed to provide a means for sites to 
        earn advertising fees by advertising and linking to Amazon.com.
      </Disclaimer>

      <CopyRight>
        © {new Date().getFullYear()} MubaCart | All Rights Reserved
      </CopyRight>
    </FooterContainer>
  );
};

export default Footer;

